import React, { useState, useEffect } from "react";
import { DocumentTypes } from "../enums/DocumentTypes";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";



export default function usePostRemoveTradeLot() {
    //LotId
    const post = async (postData: number | string) => {
        const response = await axios.post(`/TradeLotApi/RemoveTradeLot?lotId=${postData}`);
        return response.data.UpdatedItem;
    }

    const mutation = useMutation({
        mutationKey: ["RemoveTradeLot"],
        mutationFn: post,
        onSuccess: (data) => {
            console.log("%c RemoveTradeLot успешно:", "color: #b885f2; font-weight: bold; font-size: 16px;", data);
        },
        onError: (error) => {
            console.log("%c RemoveTradeLot ошибка:", "color: #f08181; font-weight: bold; font-size: 16px;", error);
        },
    });

    return {
        ...mutation,
        error: mutation.error?.response?.data?.Error || mutation.error?.message || "Неизвестная ошибка",
    };
}